import UpdateChartNotificationInterface from "@app/Interface/UpdateChartNotificationInterface";
import UserChartNotificationSettingsInterface from "@app/Interface/UserChartNotificationSettingsInterface";
import User from "@app/Interface/UserInterface";
import UpdateChartNotificationModel from "@app/Model/UpdateChartNotificationModel";
import ThresholdType from "@app/Type/ThresholdType";

export default class ChartSettingFunctions {

    /**
     * 
     * @param formSettings 
     * @returns 
     */
    static formValidation = (formSettings: UserChartNotificationSettingsInterface): [boolean, string] => {

        // eslint-disable-next-line prefer-const
        let valid = true;

        let message = "Success";

        if (formSettings.threshold_range === "above" || formSettings.threshold_range === "below") {

            // make sure they enter a postive value
            if (formSettings.threshold_value_min <= 0) {
                
                valid = false;

                message = "Please enter a positive value.";

            }

        } else if (formSettings.threshold_range === "between" || formSettings.threshold_range === "outside") {

            // make sure they enter a postive value
            if (formSettings.threshold_value_min <= 0 || formSettings.threshold_value_max <= 0) {
                
                valid = false;

                message = "Please enter positive values.";

            } else if (formSettings.threshold_value_min === formSettings.threshold_value_max) {

                valid = false;

                message = "The two values should be different."

            } else if (formSettings.threshold_value_max < formSettings.threshold_value_min) {

                valid = false;

                message = "The first value should be less than the second value."

            }


        } 

        return [valid, message];

    }

    static getChartData = (currentUser: User, settings: UserChartNotificationSettingsInterface): UpdateChartNotificationInterface => {

        const data = new UpdateChartNotificationModel();
        data.userID = currentUser.id
        data.active = settings.active
        data.chart = settings.chart
        data.fpuID = settings.fpu;
        data.thresholdRange = settings.threshold_range;
        data.thresholdMin = settings.threshold_value_min;
        data.thresholdMax = settings.threshold_value_max;

        return data;

    }

    static convertStringToThresholdType = (value: string): ThresholdType => {

        let typeValue: ThresholdType = "above";

        switch (value) {
            case "above":
                typeValue = "above";
                break;

            case "below":
                typeValue = "below";
                break;

            case "outside":
                typeValue = "outside";
                break;

            case "between":
                typeValue = "between";
                break;

            default:
                break;
        }

        return typeValue;

    }

}